const dndStructure = {
  columns: {
    'available': {id: 'available', title: 'Available', trainingIds: []},
    'selected': {id: 'selected', title: 'Selected', trainingIds: []},
  }
}

export default dndStructure
